// extracted by mini-css-extract-plugin
export default {"container":"qC-z","dimension":"rC-z","dimensionLabels":"sC-z"};